import { useEffect, useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { useAppAuth } from '@/contexts/app-auth.context'
import { OrganizationSwitcher } from '@workos-inc/widgets/organization-switcher'
import { authClient } from '@/lib/api/auth.client'

export function OrganizationSwitcherPage() {
  const { getAccessToken } = useAppAuth()
  const [accessToken, setAccessToken] = useState<string | null>(null)

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken()
      setAccessToken(token)
    }
    fetchToken()
  }, [getAccessToken])

  const handleOrganizationSwitch = async (params: {
    organizationId: string
  }) => {
    try {
      const result = await authClient.switchOrganization(params.organizationId)

      if (result.redirectUrl) {
        window.location.href = result.redirectUrl
        return
      }

      if (result.success) {
        window.location.reload()
      }
    } catch (error) {
      console.error('Error switching organization:', error)
    }
  }

  return (
    <div className="h-full overflow-y-auto mt-16">
      <div className="space-y-6 p-6 pt-0 mt-6">
        <PageHeader title="Switch between organizations or create new ones" />

        <div>
          {accessToken ? (
            <OrganizationSwitcher
              authToken={accessToken}
              switchToOrganization={handleOrganizationSwitch}
            />
          ) : (
            <div className="p-6">
              <div className="text-center">
                <p className="text-muted-foreground">Loading...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
